import { gql } from '@apollo/client'

// Copied from src/query/material-emission-factors.ts and adapted for the End of Life grid
// (story 37057). Two names are load-bearing: the introspection type name EndOfLifeGraphQl
// (lowercase "l" in GraphQl), which drives the column headers, and the root field endOfLife.
// The search widens across country name, ISO code, code and product name, because a record is a
// country + taxonomy level + product combination, not a country on its own.
export const GET_ALL_END_OF_LIFE = gql`
  query AllEndOfLife(
    $str: String
    $secondaryDataReferenceSourceType: NullableOfReferenceSourceTypeEnumOperationFilterInput
    $state: StateEnumOperationFilterInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [EndOfLifeGraphQlSortInput!]
  ) {
    secondaryDataReferenceSourceType: __type(name: "ReferenceSourceTypeEnum") {
      name
      enumValues {
        name
        description
      }
    }
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }
    productTaxonomyLevel: __type(name: "ProductTaxonomyLevelEnum") {
      name
      enumValues {
        name
        description
      }
    }
    endOfLifeRecord: __type(name: "EndOfLifeGraphQl") {
      fields {
        name
        description
      }
    }

    endOfLife(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        or: [
          { countryName: { contains: $str } }
          { countryISOCode: { contains: $str } }
          { code: { contains: $str } }
          { productName: { contains: $str } }
          { secondaryDataReferenceSourceType: $secondaryDataReferenceSourceType }
          { state: $state }
        ]
      }
      order: $order
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          code
          state
          countryName
          countryISOCode
          productTaxonomyLevel
          productName
          recyclingRates
          lastPublishedDate
          researcherName
          isVerified
          verifiedOn
          lastUpdatedName
          updated
        }
      }
    }
  }
`
